var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"8","lg":"8"}},[_c('Paychecks')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }